import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { Subscription } from 'rxjs';
import { MapHelperService } from 'src/services/map-helper.service';
import { ToastrService } from 'ngx-toastr';
import { GeoClustersFrecuencyPlacesService } from '../../../../services/GeoClustersFrecuencyPlaces.service';
import { ChartData, ChartOptions, ChartType } from 'chart.js';
import { ClusterEntry, LocationClustersDTO } from '../../../../models/LocationClustersDTO';
import { MediaMatcher } from '@angular/cdk/layout';
import { environment } from "src/environments/environment";
import { MatDialog } from '@angular/material/dialog';
import { RecurrentPlacesClusterDetailsComponent } from '../../molecules/recurrent-places-cluster-details/recurrent-places-cluster-details.component';

@Component({
  selector: 'recurrent-places', 
  templateUrl: './recurrent-places.component.html',
  styleUrls: ['./recurrent-places.component.css'],
  animations: [
    trigger("mostrarLista", [
      state("visible", style({  opacity: 1, transform: "translateY(0)",  height: "*" })),
      state("hidden", style({ opacity: 0, transform: "translateY(100%)", height: '0px', overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
  ],
})
export class RecurrentPlacesComponent {
  

  clusterGroups: LocationClustersDTO[] = [];
  pieChartLabels: string[] = [];
  pieChartData: ChartData<'pie'> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  pieChartType: ChartType = 'pie';
  pieChartOptions: ChartOptions<'pie'> = {
  plugins: {
    datalabels: {
      color: '#fff',
      font: { weight: 'bold' },
      textStrokeColor: '#000',
      textStrokeWidth: 2
    }
  }
};

  fullScreen: boolean = false;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  features: any[] = [];
  identifier: string = "";
  description: string = "";
  

  subscription_GetFeatures: Subscription;
  subscription_Visibility: Subscription;


  constructor(
    private MapHelper: MapHelperService,
    public geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    private toastrService : ToastrService,
    private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private dialog: MatDialog
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

  }

  ngOnDestroy(): void {
    if (this.subscription_GetFeatures)
      this.subscription_GetFeatures.unsubscribe();

    this.Close();
  }

  ngOnInit(): void {
    this.startRecurrentPlaces();
  }

  startRecurrentPlaces() {
    this.identifier = this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces;
    this.description = this.geoClustersFrecuencyCatalogService.descriptionRecurrentPlaces;
    this.subscription_GetFeatures = this.geoClustersFrecuencyCatalogService.GetByIdentifierGeoJson(this.identifier).subscribe(data => {
      if(!environment.production) console.log("data recurrentes", data);
      if (data.isSuccess && data.result) {
        const geoJson = JSON.parse(data.result);
        this.features = geoJson.features;
        if (this.features != null && this.features.length > 0) {
          this.processGeoJsonData(geoJson);
  
          //sacamos los colores generados del chart y los asignamos a los features
          const colors = this.pieChartData.datasets[0].backgroundColor as string[];
          for (let i = 0; i < this.features.length; i++) {
            var color = colors[i % colors.length];
            this.features[i].properties.color = color;
          }
          const updatedGeoJson = {
            type: 'FeatureCollection',
            features: this.features,
          };
          const mostProbableIndex = this.pieChartData.datasets[0].data.indexOf(Math.max(...this.pieChartData.datasets[0].data));
  
          if(!environment.production) console.log("geojson actualizado", updatedGeoJson);
          
  
          this.MapHelper.UpdateLayerGeoJson("recurrentPlacesSource",updatedGeoJson);
          this.MapHelper.ShowLayer("layer-recurrentPlaces");
          this.MapHelper.ShowLayer("layer-recurrentPlacesText");
          this.MapHelper.FitBounds(updatedGeoJson.features[mostProbableIndex].geometry);
  
          this.geoClustersFrecuencyCatalogService.isLoading = false;
        }else{
          this.toastrService.error("No se encontraron lugares recurrentes", "Error", );
          this.geoClustersFrecuencyCatalogService.isLoading = false;
          this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible = false;
          Sentry.captureMessage('RecurrentPlaces.startRecurrentPlaces: isSuccess false', { level: 'warning', extra: { response: data } });
        }
      }else{
        this.toastrService.error("No se encontraron lugares recurrentes", "Error", );
        Sentry.captureMessage('RecurrentPlaces.startRecurrentPlaces: isSuccess false', { level: 'warning', extra: { response: data } });
        this.geoClustersFrecuencyCatalogService.isLoading = false;
        this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible = false;
      }
    });
  }

  processGeoJsonData(geoJsonData: any): void {
    const features = geoJsonData.features;

    const pieLabels: string[] = [];
    const piePointsData: number[] = [];

    for (const feature of features) {
      const properties = feature.properties;
      const clusterId = properties.ClusterId;
      const points = Number(properties.PointsInCluster);


      //--------- configuracion de clusters
      //crea una entrada de un cluster
      const entry: ClusterEntry = {
        day: properties.DayName,
        hour: properties.HourOfDay,
        points: points,
      };
      var clusterGroup: LocationClustersDTO;
      //si hay un cluster nuevo, lo crea y lo agrega a la lista de clusters
      //si ya existe, lo agrega a la lista de entradas del cluster
      if (!this.clusterGroups.some(group => group.clusterId === clusterId)) {
         clusterGroup = {
          clusterId: clusterId,
          entries: [entry],
        };
        this.clusterGroups.push(clusterGroup);
      }else{
        clusterGroup = this.clusterGroups.find(group => group.clusterId === clusterId);
        if (clusterGroup) {
          clusterGroup.entries.push(entry);
        }
      }

      //----------------------------- pie
      //para pie sólo se agregan los labels y los puntos, evita repetidos
      if (pieLabels.length === 0 || !pieLabels.includes(`Cluster ${properties.ClusterId}`)) {
        pieLabels.push(`Cluster ${properties.ClusterId}`);
        piePointsData.push(points);
      }
      
    }

    // se crea la data del chart de pie
    this.pieChartLabels = pieLabels;
    const piePointsDataPercentages = piePointsData.map((points) => (points / piePointsData.reduce((total, puntos) => total + puntos, 0)) * 100);
    this.pieChartData = {
      labels: pieLabels,
      datasets: [
        {
          data: piePointsDataPercentages.map(value => Number(value.toFixed(2))),
          backgroundColor: this.getColors(piePointsDataPercentages.length),
        },
      ],
    };
  }

  getColors(count: number): string[] {
    const colors = [
      '#FF6384', '#36A2EB', '#FFCE56', '#8E44AD', '#2ECC71',
      '#E67E22', '#3438F9', '#D9C40F', '#E74C3C', '#1ABC9C'
    ];
    // por si hay más, se hace uno al azar
    while (colors.length < count) {
      colors.push(`#${Math.floor(Math.random()*16777215).toString(16)}`);
    }
    return colors.slice(0, count);
  }

  //para que funcione, el orden de los features y de los labels tiene que ser el mismo
  onPieChartClick(event: { event?: MouseEvent, active?: {}[] }) {
    if (event.active && event.active.length > 0) {
      const chartElement = event.active[0] as any;
      const dataIndex = chartElement.index;
  
      const feature = this.features[dataIndex];
      if (feature) {
        this.flyToPlace(feature);
        
        const clusterGroup = this.clusterGroups[dataIndex];
        const percentage = this.pieChartData.datasets[0].data[dataIndex] as number;
        const color = (this.pieChartData.datasets[0].backgroundColor as string[])[dataIndex];
        
        this.dialog.open(RecurrentPlacesClusterDetailsComponent, {
          panelClass: 'dialog-panel-locations-style',
          data: {
            clusterId: clusterGroup.clusterId,
            entries: clusterGroup.entries,
            color: color,
            percentage: percentage,
            identifier: this.identifier,
            description: this.description
          },
          hasBackdrop: false,
          ...(!this.mobileQuery.matches ? { width: '100vw', height: '100vh', maxWidth: '100vw', maxHeight: '100vh' } : {})
        });
      }
    }
  }

  Close(){
    this.MapHelper.UpdateLayerGeoJson("recurrentPlacesSource", this.MapHelper.Empty_GeoJson);
    this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(false);
    this.MapHelper.HideLayer("layer-recurrentPlaces");
    this.MapHelper.HideLayer("layer-recurrentPlacesText");
  }

  flyToPlace(feature: any) {
    var centroide = this.MapHelper.getpolygonPointsCentroid(feature.geometry.coordinates[0]);
    this.MapHelper.FlyToCamera(centroide[1].toString(), centroide[0].toString(), "16");
  }

}
